import { useState, useEffect } from "react";
import axios from "axios";
import React from "react";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import Navmain from '../../main/header';
import Footer from '../../main/footer';
import CategorySection from './InquiryCategories';
import GetQuoteForm from '../../main/GetQuote';
import WhatsappCenteredButton from './WhatsappCenteredButton';

const WhatsappInquiryPage = () => {
    return (
        <div className="d-flex flex-column min-vh-100">
          <Navmain />
          <main className="main flex-grow-1 d-flex align-items-center justify-content-center">
            <section className="bg-home9 w-100">
              <div className="container d-flex justify-content-center align-items-center">
              
              
                  <div className="mt-3 p-3 pt-0" style={{ boxShadow: '0px 0px 6px 2px #ccc', borderRadius: '16px', background: '#fff' }}>
                  
                  <div className="row">
                  <div className="col-12 pb-4">
                  <h2 className="main-heading-style color-gray-900 text-center mb-2 mt-3">Submit Your Inquiry</h2>
                </div>
  {/* Right - Form Section */}
  <div className="col-12 col-lg-6">
      <GetQuoteForm inquiry={true} />
  </div>
<div className="col-12 col-lg-6 p-4 justify-content-center text-center align-items-center">
<div className="px-md-4">
      <h5 className="mb-3 text-dark fw-bold">Currently Dealing in These Categories – For Others, Submit Your Inquiry</h5>
      <p className="text-muted">
      Not sure which product to quote or don’t see your category? Send us an inquiry. Currently, Get Quote supports only the categories below. For other products, fill out the form — we’ll reach out to assist you.
      </p>
      <CategorySection inquiry={true} />
    </div>
<hr/>
    <div className="text-center mt-4">
      <WhatsappCenteredButton />
    </div>
  </div>


</div>
                  </div>
          
              </div>
            </section>
          </main>
          <Footer />
        </div>
      );
}

export default WhatsappInquiryPage;